<div class="modal-header">
    <h4 class="modal-title">Adicionar Modalidade</h4>
    <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
  </div>
  <div class="modal-body">
    <label for="combo">Escolha a modalidade:</label>
    <select class="form-select" id="combo" [(ngModel)]="modalidade">
        <option *ngFor="let valor of modalidades" [ngValue]="valor.sigla">{{valor.sigla}}</option>
    </select>
    <div *ngIf="mensagemAviso" class="alert alert-warning">
        {{mensagemAviso}}
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
    <button class="btn btn-primary" (click)="salvar()">Salvar</button>
</div>